import {BrowserModule} from '@angular/platform-browser';
import {ApplicationConfig, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import RequestInterceptor from '../interceptor/request.interceptor';
import {SplashScreenModule} from './parts/splash-screen/splash-screen.module';
import { BaseComponent } from './base/base.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatInputModule} from '@angular/material/input';
import {ApiModule} from '../api/api.module';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DialogsModule} from './dialogs/dialogs.module';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {
    NGX_MAT_MOMENT_FORMATS,
    NgxMatMomentAdapter,
    NgxMatMomentModule
} from '@angular-material-components/moment-adapter';
import {MatIconModule} from '@angular/material/icon';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule, MatRippleModule} from '@angular/material/core';
import {AddOverlayModule} from './parts/add-overlay/add-overlay.module';
import { environment } from '../environments/environment';
import {ContextBarModule} from './parts/context-bar/context-bar.module';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from '@angular/material/dialog';
import {CooperationContactModule} from './parts/cooperation-contact/cooperation-contact.module';
import {RevenueModule} from './parts/revenue/revenue.module';
import {NoteModule} from './parts/note/note.module';
import {PipesModule} from './pipes/pipes.module';
import * as moment from 'moment-timezone';
import {MatMenuModule} from "@angular/material/menu";
import {AvatarPlaceholderModule} from "./parts/avatar-placeholder/avatar-placeholder.module";
import {DirectivesModule} from "./directives/directives.module";
import { register } from 'swiper/element/bundle';
import {QuillModule} from "ngx-quill";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import {DoingModule} from "./parts/doing/doing.module";
import {MatChipsModule} from "@angular/material/chips";
import {TaskModule} from "./parts/task/task.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SelectionItemsModule} from "./selection-items/selection-items.module";
import {InViewportModule} from "@kumanu/angular-inviewport";
import { CalendarModule } from './pages/calendar/calendar.module';
import { PrivateEventComponent } from './parts/private-event/private-event.component';
import {CurrencyInputModule} from "./parts/currency-input/currency-input.module";
import {DocumentModule} from "./parts/document/document.module";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {NgxMatDatetimePickerModule} from "@angular-material-components/datetime-picker";
import { VacationComponent } from './parts/vacation/vacation.component';
import { MiniCalendarModule } from './parts/mini-calendar/mini-calendar.module';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
    return player;
}


register();
registerLocaleData(localeDe, 'de', localeDeExtra);

moment.tz.setDefault('Europe/Berlin');


@NgModule({
    declarations: [
        AppComponent,
        BaseComponent,
        PrivateEventComponent,
        VacationComponent
    ],
    imports: [
        CommonModule,
        AvatarPlaceholderModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MatSidenavModule,
        AppRoutingModule,
        SplashScreenModule,
        MatInputModule,
        DialogsModule,
        NoteModule,
        ApiModule,
        MatIconModule,
        NgxMatMomentModule,
        MatRippleModule,
        AddOverlayModule,
        CooperationContactModule,
        /*ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerImmediately'
        }),*/
        ContextBarModule,
        RevenueModule,
        PipesModule,
        MatMenuModule,
        DirectivesModule,
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent

                    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                    [{'header': [1, 2, 3, 4, 5, 6, false]}],

                    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                    [{'align': []}],

                    ['clean'],                                         // remove formatting button

                    ['link', 'image', 'video']                         // link and image, video
                ]
            }
        }),
        LottieModule.forRoot({player: playerFactory}),
        DoingModule,
        MatChipsModule,
        TaskModule,
        FormsModule,
        SelectionItemsModule,
        InViewportModule,
        CalendarModule,
        CurrencyInputModule,
        DocumentModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatOptionModule,
        NgxMatDatetimePickerModule,
        ReactiveFormsModule,
        InViewportModule,
        MiniCalendarModule
    ],
    providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: RequestInterceptor, // this class adds SSO auth to header
        multi: true
    },
        {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 3000}},
        {provide: LOCALE_ID, useValue: 'de'},
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {panelClass: 'custom-dialog', hasBackdrop: true}},
        {provide: DateAdapter, useClass: NgxMatMomentAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: NGX_MAT_MOMENT_FORMATS},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' }
    ],
    bootstrap: [AppComponent],
    exports: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
